<button (click)="export()" style="margin: 20px 0px" class="btn btn-success">Export data</button>
<mat-form-field>
    <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filtre">
</mat-form-field>
<div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
        <ng-container matColumnDef="star" stickyEnd>
            <th class="opCol" mat-header-cell *matHeaderCellDef></th>
            <td class="opCol" mat-cell *matCellDef="let element">
                <button mat-icon-button [routerLink]="['/users', element.id]">
        <mat-icon>remove_red_eye</mat-icon>
      </button>
                <!-- <button mat-icon-button (click)="removeElemet(element)">
        <mat-icon>delete</mat-icon>
      </button> -->
            </td>
        </ng-container>

        <!-- <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
            <td mat-cell *matCellDef="let row"> {{row.id}} </td>
        </ng-container> -->

        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
            <td mat-cell *matCellDef="let row"> {{row.email}} </td>
        </ng-container>

        <ng-container matColumnDef="lastConnection">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Last connection </th>
            <td mat-cell *matCellDef="let row"> {{row.lastConnection.toDate() }} </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let element" [attr.colspan]="3">
                <div class="example-element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                    <div class="container" style="padding: 20px;">
                        <mat-card style="background-color: #e9e9e9">
                            <div><span style="font-weight: bold;">Last device id: </span>{{element.lastDevice}} </div>
                            <div><span style="font-weight: bold;">Last device name: </span>{{element.lastDeviceName}} </div>
                            <div><span style="font-weight: bold;">Last device platform: </span>{{element.lastDevicePlatform}} </div>
                            <div><span style="font-weight: bold;">Last device version: </span>{{element.lastDeviceVersion}} </div>
                            <div><span style="font-weight: bold;">Last application version: </span>{{element.lastAppVersion}} </div>
                        </mat-card>
                    </div>
                </div>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="example-element-row" [class.example-expanded-row]="expandedElement === row" (click)="expandedElement = expandedElement === row ? null : row"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[25, 50, 100, 150]"></mat-paginator>
</div>